import Button from "components/common/buttons/buttons";
import useIsMobile from "states/deviceState";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import TopHeader from "components/common/header";
import { useCallback, useEffect, useRef, useState } from "react";
import Title from "components/common/title";
import { TYPO } from "styles/Typo";
import Image from "next/image";
import CustomToast from "components/atoms/CustomToast";
import { ICONS } from "components/common/Icons";
import FixedButton from "components/common/buttons/FixedButtons";
import { toast } from "react-toastify";
import { useSession } from "next-auth/react";
import * as Sentry from "@sentry/nextjs";

function AlarmVerfyPhoneModal({ setModalOpen }: any) {
  const isMobile = useIsMobile();

  const router = useRouter();

  const { t } = useTranslation("detail");
  const [step, setStep] = useState(1);

  const [phoneError, setPhoneError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [focused, setForcused] = useState(false);

  const clearInput = () => {
    setPhoneNumber("");
  };

  const handleBlur = () => {
    // 블러 이벤트 처리를 지연시켜 버튼 클릭 이벤트가 먼저 처리될 수 있도록 함
    setTimeout(() => {
      setForcused(false);
    }, 100); // 100ms 지연
  };

  useEffect(() => {
    setPhoneError("");
  }, [phoneNumber]);

  const isExistPhone = async () => {
    const data = await fetch(`/api/auth/existPhone`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ phone: phoneNumber }),
    });
    const result = await data.json();

    if (result.status == 409 || result.message === "user already exists") {
      return true;
    }
    if (result.status == 200) {
      return false;
    }
    if (result.status == 500) {
      toast.error(t("서버 에러가 발생했습니다"));
      throw new Error("서버 에러가 발생했습니다");
    }
  };

  if (step === 1) {
    return (
      <>
        <div
          className="w-full h-screen"
          style={
            !isMobile ? { height: "calc(100vh - 160px)" } : { height: "100vh" }
          }
        >
          <TopHeader
            clickHandler={() => {
              // setModalOpen(false);
              setModalOpen(false);
            }}
          />
          <div className="w-full flex-col justify-start items-center gap-6 inline-flex">
            <div className="w-full">
              <Title title={t("phoneTitle")} type="vertical" size="lg" />
              <div className=" relative w-full  cursor-pointer px-6 flex-col justify-start gap-[6px]  inline-flex">
                <label
                  className={`${TYPO.TYPO7_MD}  ${
                    phoneError.length > 0
                      ? "text-red40"
                      : focused
                      ? "text-blue40"
                      : "text-gray70"
                  } `}
                >
                  {t("phoneNumber")}
                </label>
                <div className="relative w-full">
                  <input
                    onClick={(e) => e.stopPropagation()}
                    required
                    type="text"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    className={`rounded-0 bg-transparent line-input h-[52px] py-2 ${
                      TYPO.TYPO5_MD
                    } text-gray90 ${
                      phoneError.length > 0 && "error-line-input "
                    } text-zinc-800 border-b-2 border-zinc-200 w-full`}
                    placeholder={"01012345678"}
                    value={phoneNumber}
                    onChange={(e) =>
                      setPhoneNumber(e.target.value.replace(/\D/g, ""))
                    }
                    onFocus={() => setForcused(true)}
                    onBlur={handleBlur}
                    style={{
                      WebkitAppearance: "none",
                      WebkitBorderRadius: 0,
                    }}
                  />
                  {focused && (
                    <div
                      className="w-[30px] h-[30px] flex justify-center items-center z-30 x-btn absolute top-[50%] translate-y-[-50%] cursor-pointer right-[0px]"
                      onClick={clearInput}
                    >
                      <Image
                        alt="x"
                        src={"/images/icons/x.svg"}
                        height={20}
                        width={20}
                      />
                    </div>
                  )}
                </div>
                {phoneError.length > 0 && (
                  <span className={`${TYPO.TYPO8_MD} text-red40`}>
                    {phoneError}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        {isMobile && (
          <div
            className={`step-${step} h-[104px] fixed pb-[34px] bottom-0 left-0 w-full  px-5 pt-4  bg-white flex-col justify-start items-start gap-2.5 inline-flex`}
          >
            <Button
              clickHandler={async () => {
                if (phoneNumber.length !== 0) {
                  setPhoneError(t(""));
                  if (
                    phoneNumber.length !== 11 ||
                    phoneNumber.slice(0, 3) !== "010"
                  ) {
                    setPhoneError(t("IncorrectFormat"));
                    return;
                  }
                  try {
                    const isExistPhoneUser = await isExistPhone();
                    // 이미 있는 번호일 경우
                    if (isExistPhoneUser) {
                      setPhoneError(t("aleadyPhone"));
                      return;
                    }
                    return setStep(2);
                  } catch (e) {
                    Sentry.captureException(e);

                    // console.error(e);
                  }
                }
              }}
              text={t("next")}
              type="primary"
              size="xl"
              width="w-full"
              disabled={phoneNumber.length === 0}
            />
          </div>
        )}
        {!isMobile && (
          <FixedButton
            text={t("next")}
            type="primary"
            size="xl"
            width="w-full"
            disabled={phoneNumber.length === 0}
            btnClass={`step-${step}`}
            isDesktop={true}
            rounded={true}
            onclick={async () => {
              if (phoneNumber.length !== 0) {
                setPhoneError(t(""));
                if (
                  phoneNumber.length !== 11 ||
                  phoneNumber.slice(0, 3) !== "010"
                ) {
                  setPhoneError(t("IncorrectFormat"));
                  return;
                }
                try {
                  const isExistPhoneUser = await isExistPhone();
                  // 이미 있는 번호일 경우
                  if (isExistPhoneUser) {
                    setPhoneError(t("aleadyPhone"));
                    return;
                  }
                  return setStep(2);
                } catch (e) {
                  Sentry.captureException(e);

                  // console.error(e);
                }
              }
            }}
          />
        )}
      </>
    );
  } else if (step === 2) {
    return (
      <Step2
        phone={phoneNumber}
        setPhoneNumber={setPhoneNumber}
        setStep={setStep}
        setModalOpen={setModalOpen}
      />
    );
  } else return <></>;
}

function Step2({
  phone,
  setPhoneNumber,
  setStep,
  setModalOpen,
}: {
  phone: string;
  setPhoneNumber: any;
  setStep: any;
  setModalOpen: any;
}) {
  const router = useRouter();
  const { data: session, update } = useSession();
  const { t } = useTranslation("detail");

  useEffect(() => {
    sendVerificationCode();
  }, []);

  const formatPhoneNumber = (phoneNumberString: string) => {
    // 01012341234 -> 010-1234-1234
    const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
    if (match) {
      return match[1] + "-" + match[2] + "-" + match[3];
    }
  };

  const isMobile = useIsMobile();
  //문자 코드 확인 API
  const isVerifyCode = async () => {
    const data = await fetch(`/api/auth/phoneVerifyCodeConfirm`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        phoneNumber: phone,
        inputCode: verifyCode,
      }),
    });
    const result = await data.json();

    if (result.success) {
      return true;
    }
    if (!result.success) {
      setError(
        router.locale === "ko"
          ? "인증번호가 일치하지 않아요"
          : "The codes do not match."
      );
      return false;
    }
  };

  const [error, setError] = useState("");
  const [focused, setFocused] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [verifyTime, setVerifyTime] = useState(180); // 문자 코드 입력 시간 3분

  //문자 코드 전송 API
  const sendVerificationCode = async () => {
    const data = await fetch(`/api/auth/phoneVerifyCode`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ phoneNumber: phone }),
    });
    const result = await data.json();
  };

  const clearInput = () => {
    setVerifyCode("");
  };

  const handleBlur = () => {
    setTimeout(() => {
      setFocused(false);
    }, 100); // 100ms 지연
  };

  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (verifyTime > 0) {
        setVerifyTime(verifyTime - 1);
      }
      if (verifyTime === 0) {
        setError(t("expiredCode"));
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [verifyTime]);

  const [toastMessage, setToastMessage] = useState("");
  const [toastVisible, setToastVisible] = useState(false);

  const onClose = useCallback(() => {
    setToastVisible(false);
  }, []);

  useEffect(() => {
    setError("");
  }, [verifyCode]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const [count, setCount] = useState(0);
  const updateUserPhone = async () => {
    const data = await fetch(`/api/auth/alarm?email=${session?.user?.email}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ phone: phone }),
    });
    const result = await data.json();
    if (result.message === "success") {
      await update();
      setModalOpen(false);
    } else {
      toast.error(t("서버 에러가 발생했습니다"));
    }
  };

  return (
    <div
      className="w-full"
      style={
        !isMobile ? { height: "calc(100vh - 160px)" } : { height: "100vh" }
      }
    >
      <TopHeader
        clickHandler={() => {
          // setModalOpen(false);
          setModalOpen(false);
        }}
      />
      <div className="w-full flex-col h-full  inline-flex bg-white">
        <div className="w-full flex-col justify-start items-center gap-6 inline-flex">
          <Title title={t("phoneverifyTitle")} type="vertical" size="lg" />

          <div className="relative w-full cursor-pointer px-6 flex-col justify-start items-center gap-2.5 inline-flex">
            <div
              className={`w-full flex-col justify-start  gap-1.5 inline-flex`}
            >
              <label
                className={`${TYPO.TYPO7_MD}  ${
                  error ? "text-red40" : focused ? "text-blue40" : "text-gray70"
                } `}
              >
                {t("verifyCode")}
              </label>
              <div className="w-full relative">
                <input
                  ref={inputRef}
                  className={`w-full line-input  py-2 h-[52px] TYPO.TYPO5_MD ${
                    error && "error-line-input"
                  } pl-0 text-zinc-800 border-b-2 border-zinc-200 `}
                  onFocus={() => setFocused(true)}
                  onBlur={handleBlur}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  value={verifyCode}
                  onChange={(e) => {
                    if (e.target.value.length > 7) return;
                    setVerifyCode(e.target.value.replace(/\D/g, ""));
                  }}
                  placeholder={t("verifyInputPlaceholder")}
                  style={{
                    WebkitAppearance: "none",
                    WebkitBorderRadius: 0,
                  }}
                />
                {focused && (
                  <div
                    className="w-[30px] h-[30px] flex justify-center items-center z-30 x-btn absolute top-[50%] translate-y-[-50%] cursor-pointer right-[52px]"
                    onClick={clearInput}
                  >
                    <Image
                      alt="x"
                      src={"/images/icons/x.svg"}
                      height={20}
                      width={20}
                    />
                  </div>
                )}
                <span
                  className={`${TYPO.TYPO7_MD} ${
                    error ? "text-red40" : "text-gray50"
                  }  absolute  right-[10px] top-[50%] translate-y-[-50%] `}
                >{`${Math.floor(verifyTime / 60)}:${
                  verifyTime % 60 < 10
                    ? "0" + (verifyTime % 60)
                    : verifyTime % 60
                }`}</span>
              </div>

              {error && (
                <span className={`${TYPO.TYPO8_MD} text-red40 `}>{error}</span>
              )}
            </div>
          </div>
        </div>
        <div className="px-6 mt-[30px] flex flex-col gap-4">
          <p className={`${TYPO.TYPO7_1_RG} text-gray50`}>
            {phone
              ? router.locale === "ko"
                ? ` ${formatPhoneNumber(phone)}로 전송했어요.`
                : `Sent to ${formatPhoneNumber(phone)}.`
              : ""}
          </p>
          <div className="flex flex-col gap-3">
            <Button
              type="tertiary"
              size="sm"
              text={t("resendCode")}
              width="w-fit"
              clickHandler={async () => {
                // 인증번호 다시 받기
                if (count > 10) {
                  setToastMessage(t("resentTooManyTimes"));
                  setToastVisible(true);
                  return;
                }
                setCount((prev: number) => prev + 1);
                setError("");
                await sendVerificationCode();
                setToastVisible(true);
                setToastMessage(t("resentCodeToast"));
                setVerifyCode("");
                setVerifyTime(180);
              }}
              icon={ICONS.FORWARD}
              iconHeight={12}
              iconWidth={12}
            />
            <Button
              type="tertiary"
              size="sm"
              text={t("rewriteNumber")}
              width="w-fit"
              clickHandler={() => {
                setError("");
                setPhoneNumber("");
                setStep(1);
              }}
              icon={ICONS.FORWARD}
              iconHeight={12}
              iconWidth={12}
            />
          </div>
        </div>
      </div>

      {isMobile ? (
        <div
          className={`step-3 h-[104px] fixed pb-[34px] bottom-0 left-0 w-full  px-5 pt-4  bg-white flex-col justify-start items-start gap-2.5 inline-flex`}
        >
          <Button
            clickHandler={async () => {
              if (verifyTime === 0) {
                setError(t("expiredCode"));
                return;
              }

              const isValid = await isVerifyCode();
              if (isValid) {
                // 유저 휴대폰 번호 업데이트(API)
                updateUserPhone();
              }
            }}
            text={t("next")}
            type="primary"
            size="xl"
            width="w-full"
            btnClass={`step-3`}
          />
        </div>
      ) : (
        <FixedButton
          text={t("next")}
          type="primary"
          size="xl"
          width="w-full"
          btnClass={`step-3`}
          isDesktop={true}
          rounded={true}
          onclick={async () => {
            if (verifyTime === 0) {
              setError(t("expiredCode"));
              return;
            }
            const isValid = await isVerifyCode();
            if (isValid) {
              // 유저 휴대폰 번호 업데이트(API)
              updateUserPhone();
            }
          }}
        />
      )}
      <CustomToast
        message={toastMessage}
        isVisible={toastVisible}
        onClose={onClose}
        isSuccess={toastMessage === t("resentTooManyTimes") ? false : true}
        width={
          toastMessage === t("resentTooManyTimes")
            ? 330
            : router.locale === "ko"
            ? 220
            : 300
        }
        fromTop={true}
      />
    </div>
  );
}

export default AlarmVerfyPhoneModal;
